exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uk-button-primary[data-v-30b966b6]{padding:6px 12px;margin-left:10px}.student__info[data-v-30b966b6]{text-align:center;margin-top:20px}.student__desc[data-v-30b966b6]{margin:0;font-size:13px}.student__desc span[data-v-30b966b6]{font-weight:bolder}.class__link[data-v-30b966b6]{color:#1e87f0}.class__link[data-v-30b966b6]:hover{text-decoration:underline}.section__tabs[data-v-30b966b6]{margin-top:20px}.rating-table[data-v-30b966b6]{width:100%;max-width:600px}.statistics[data-v-30b966b6]{box-sizing:border-box;width:100%}.student__login[data-v-30b966b6]{color:#999}", ""]);

// exports
